import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ADMIN_PORTAL_URL } from '@lib/tasks';
import { TranslatePipe } from '@ngx-translate/core';

import { PartnerImportStatus } from '@lib/core/models/partners.interface';

import { TASK_DATA } from '../../../core/contracts/task-data.contract';
import { Task, TaskType } from '../../../core/models/task.interface';

@Component({
  selector: 'tasks-orphaned-offering-task-details',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './orphaned-offering-task-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col gap-6' },
})
export class OrphanedOfferingTaskDetailsComponent {
  private readonly adminPortalUrl = inject(ADMIN_PORTAL_URL);

  protected readonly task = inject<Task<TaskType.OrphanedOffering>>(TASK_DATA);

  protected openPartnerOfferings(): void {
    const params = new URLSearchParams({
      importStatus: PartnerImportStatus.Orphaned,
      mappedOnly: 'true',
    });
    const url = `${this.adminPortalUrl}/partners/${this.task.data.partnerId}/offerings?${params.toString()}`;
    window.open(url, '_blank', 'noopener noreferrer');
  }
}
